"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9794],{

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 11439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13328);


var useShopUrl = function(modelId) {
    var selectedColorCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedDetailingCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedUpholsteryCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var selectedAccessoriesCodes = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.accessories;
    }).selectedAccessoriesCodes;
    var model = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.wizard;
    }).model;
    var getShopUrl = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!model || model.id !== modelId) return "/shop/".concat(modelId);
        var url = new URLSearchParams();
        if (selectedColorCode) url.append("color", selectedColorCode);
        if (selectedDetailingCode) url.append("detailing", selectedDetailingCode);
        if (selectedUpholsteryCode) url.append("upholstery", selectedUpholsteryCode);
        if (selectedAccessoriesCodes && Array.isArray(selectedAccessoriesCodes)) {
            selectedAccessoriesCodes.forEach(function(code) {
                return url.append("accessories", code);
            });
        }
        return "/shop/".concat(modelId, "?").concat(url.toString()) || 0;
    }, [
        model,
        modelId,
        selectedColorCode,
        selectedDetailingCode,
        selectedUpholsteryCode,
        selectedAccessoriesCodes, 
    ]);
    return getShopUrl;
};
/* harmony default export */ __webpack_exports__["Z"] = (useShopUrl);


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 58280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modelsPage_ModelsPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./reusable/BackButton.tsx + 1 modules
var BackButton = __webpack_require__(1094);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(19393);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/hooks/useShopUrl.tsx
var useShopUrl = __webpack_require__(11439);
// EXTERNAL MODULE: ./common/bit/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(49138);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./components/modelsPage/ModelCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        " {\n    padding: ",
        ";\n    flex-direction: row;\n  }\n  ",
        " {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 267px;\n    height: 275px;\n    margin-bottom: 70px;\n\n    transform: ",
        ";\n    opacity: ",
        ";\n\n    transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n    transition-delay: 0.3s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n  ",
        " {\n    text-align: center;\n    font-weight: normal;\n    font-size: 24px;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  margin-bottom: 0;\n  text-align: right;\n  line-height: 1;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n\n  font-size: ",
        ";\n  color: ",
        ";\n  width: 200px;\n  height: 40px;\n  ",
        " {\n    text-align: center;\n    font-size: 14px;\n    margin: 0px auto;\n    width: auto;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 30px;\n  ",
        " {\n    width: 100%;\n    justify-content: center;\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: 500/303;\n  width: 100%;\n\n  ",
        " {\n    margin-left: 20px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelCard__StyledWrapper",
    componentId: "sc-f81e781a-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$futureModel ? "20px 10px" : "20px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateY(-50px)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).attrs({
    variant: "h3"
}).withConfig({
    displayName: "ModelCard__StyledTitle",
    componentId: "sc-f81e781a-1"
})(_templateObject1(), function(p) {
    return p.$left ? "left" : "auto";
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledAnnouncement = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).withConfig({
    displayName: "ModelCard__StyledAnnouncement",
    componentId: "sc-f81e781a-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledPrice = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ModelCard__StyledPrice",
    componentId: "sc-f81e781a-3"
})(_templateObject3(), function(p) {
    return p.$left ? "left" : "auto";
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledLicenseFee = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ModelCard__StyledLicenseFee",
    componentId: "sc-f81e781a-4"
})(_templateObject4(), function(p) {
    return p.$left ? "left" : "auto";
}, function(p) {
    return p.$left ? "10px" : "14px";
}, function(p) {
    return p.theme.colors.onyx;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButtonRow = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledRow */.N0).withConfig({
    displayName: "ModelCard__StyledButtonRow",
    componentId: "sc-f81e781a-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "contained"
}).withConfig({
    displayName: "ModelCard__StyledButton",
    componentId: "sc-f81e781a-6"
})(_templateObject6(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLinkBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ModelCard__StyledLinkBox",
    componentId: "sc-f81e781a-7"
})(_templateObject7(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelCard__StyledImageContainer",
    componentId: "sc-f81e781a-8"
})(_templateObject8(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var ModelCard = function(param) {
    var modelData = param.modelData, _type = param.type, type = _type === void 0 ? "main" : _type, inView = param.inView;
    var isFinance = type === "finance";
    var isShop = type === "shop";
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var futureModel = modelData.carState === "Future";
    var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", modelData.id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelData.name));
    var shopUrl = (0,useShopUrl/* default */.Z)(modelData.id);
    var isInShop = modelData.isInShop;
    var linkUrl = isShop ? shopUrl : isFinance ? (modelData === null || modelData === void 0 ? void 0 : modelData.link) ? (modelData === null || modelData === void 0 ? void 0 : modelData.link) + "?openPopup=true" : carLink + "?openPopup=true" : (modelData === null || modelData === void 0 ? void 0 : modelData.link) || carLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        $inView: inView,
        $futureModel: futureModel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                href: linkUrl,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkBox, {
                    component: "a",
                    role: "presentation",
                    "aria-hidden": "true",
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
                        onClick: function() {
                            return (0,analytics/* trackModelsPageClicks */.Af)();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                            image: modelData === null || modelData === void 0 ? void 0 : modelData.image,
                            cover: false,
                            imageSizes: [
                                "150px",
                                "267px"
                            ],
                            alt: modelData === null || modelData === void 0 ? void 0 : modelData.name
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledCol */.N6, {
                $fullWidth: true,
                $notCenter: true,
                $gap: isDesktop ? "10px" : "4px",
                children: !(isFinance || isShop) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: modelData === null || modelData === void 0 ? void 0 : modelData.name
                        }),
                        isInShop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnnouncement, {
                            children: "עכשיו בהנחת אונליין"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                            children: futureModel ? "".concat(modelData === null || modelData === void 0 ? void 0 : modelData.secondaryTitle) : "החל מ-₪".concat(modelData === null || modelData === void 0 ? void 0 : modelData.price.toLocaleString())
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLicenseFee, {
                            children: (modelData === null || modelData === void 0 ? void 0 : modelData.licenceFee) && !futureModel ? "בתוספת אגרת רישוי בסך ₪".concat(modelData === null || modelData === void 0 ? void 0 : modelData.licenceFee.toLocaleString(), ' כולל מע"מ') : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    href: (modelData === null || modelData === void 0 ? void 0 : modelData.link) || carLink,
                                    title: modelData === null || modelData === void 0 ? void 0 : modelData.name,
                                    noEncoding: futureModel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                hidden: true,
                                                children: modelData === null || modelData === void 0 ? void 0 : modelData.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                children: "גלו עוד"
                                            })
                                        ]
                                    })
                                }),
                                !futureModel && isInShop && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    href: shopUrl,
                                    title: modelData === null || modelData === void 0 ? void 0 : modelData.name,
                                    noEncoding: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                hidden: true,
                                                children: modelData === null || modelData === void 0 ? void 0 : modelData.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                children: "להזמנה"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: linkUrl,
                    passHref: true,
                    noEncoding: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinkBox, {
                        component: "a",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                $left: isFinance || isShop,
                                children: modelData === null || modelData === void 0 ? void 0 : modelData.name
                            }),
                            isShop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnnouncement, {
                                children: modelData === null || modelData === void 0 ? void 0 : modelData.secondaryTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                                $left: isFinance || isShop,
                                children: "החל מ-₪".concat(modelData === null || modelData === void 0 ? void 0 : modelData.price.toLocaleString())
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLicenseFee, {
                                $left: isFinance || isShop,
                                children: (modelData === null || modelData === void 0 ? void 0 : modelData.licenceFee) ? "בתוספת אגרת רישוי בסך ₪".concat(modelData === null || modelData === void 0 ? void 0 : modelData.licenceFee.toLocaleString(), ' כולל מע"מ') : ""
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var modelsPage_ModelCard = (ModelCard);

;// CONCATENATED MODULE: ./components/modelsPage/ModelsPage.tsx

function ModelsPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    ModelsPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  width: calc(100% - 40px);\n  background-color: ",
        ";\n  height: 0.5px;\n  ",
        " {\n    width: 100%;\n    background-color: ",
        ";\n    height: 1px;\n  }\n"
    ]);
    ModelsPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    margin: 0 10px;\n  }\n  ",
        " {\n    padding: 40px;\n  }\n  ",
        " {\n    padding: 40px 80px;\n  }\n"
    ]);
    ModelsPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  padding: 40px 20px 40px 60px;\n  margin-bottom: 106px;\n  position: relative;\n  ",
        " {\n    padding: 40px 60px 40px 160px;\n  }\n"
    ]);
    ModelsPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-top: 40px;\n    display: grid;\n    grid-gap: 22px;\n    grid-template-columns: ",
        ";\n    justify-content: center;\n  }\n  ",
        " {\n    grid-template-columns: repeat(4, 267px);\n    grid-gap: 60px;\n  }\n"
    ]);
    ModelsPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-top: 40px;\n    display: grid;\n    grid-gap: 22px;\n    grid-template-columns: 1fr;\n    justify-content: center;\n  }\n  ",
        " {\n    grid-template-columns: 1fr;\n\n    grid-gap: 60px;\n  }\n"
    ]);
    ModelsPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 7px 10px 5px;\n"
    ]);
    ModelsPage_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 24px;\n  color: ",
        ";\n  ",
        " {\n    padding: 8px 0px;\n  }\n  ",
        " {\n    font-size: 28px;\n    height: 45px;\n  }\n"
    ]);
    ModelsPage_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ModelsPage_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  color: ",
        ";\n  text-align: center;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 140%;\n  letter-spacing: 0.05em;\n  margin: 0;\n\n  ",
        " {\n    font-size: 28px;\n    letter-spacing: 0.09em;\n  }\n"
    ]);
    ModelsPage_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  text-align: center;\n  color: ",
        ";\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 20px;\n    line-height: 160%;\n    letter-spacing: 0.03em;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: MazdaType;\n  font-size: 28px;\n  font-weight: 400;\n  ",
        " {\n    font-weight: 500;\n    font-size: 32px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  ",
        " {\n    position: absolute;\n    top: 0;\n  }\n  &:hover {\n    background: none;\n    border: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







var ModelsPage_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelsPage__StyledWrapper",
    componentId: "sc-ec6cb697-0"
})(ModelsPage_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(Divider/* default */.Z).withConfig({
    displayName: "ModelsPage__StyledDivider",
    componentId: "sc-ec6cb697-1"
})(ModelsPage_templateObject1(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledWhiteSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelsPage__StyledWhiteSection",
    componentId: "sc-ec6cb697-2"
})(ModelsPage_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.up("xl");
});
var StyledDesktopGreySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelsPage__StyledDesktopGreySection",
    componentId: "sc-ec6cb697-3"
})(ModelsPage_templateObject3(), function(p) {
    return p.theme.breakpoints.up("xl");
});
var StyledCarsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelsPage__StyledCarsGrid",
    componentId: "sc-ec6cb697-4"
})(ModelsPage_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $hasComingSoon = param.$hasComingSoon;
    return $hasComingSoon ? "repeat(3, 267px)" : "repeat(4, 267px)";
}, function(p) {
    return p.theme.breakpoints.up("xl");
});
var StyledCarsGridWhite = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelsPage__StyledCarsGridWhite",
    componentId: "sc-ec6cb697-5"
})(ModelsPage_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.up("xl");
});
var StyledMobileBackWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelsPage__StyledMobileBackWrapper",
    componentId: "sc-ec6cb697-6"
})(ModelsPage_templateObject6());
var StyledComingSoonText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ModelsPage__StyledComingSoonText",
    componentId: "sc-ec6cb697-7"
})(ModelsPage_templateObject7(), function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledFinanceHeader = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "ModelsPage__StyledFinanceHeader",
    componentId: "sc-ec6cb697-8"
})(ModelsPage_templateObject8(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledFinanceHeaderSmall = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "ModelsPage__StyledFinanceHeaderSmall",
    componentId: "sc-ec6cb697-9"
})(_templateObject9(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledMazda = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ModelsPage__StyledMazda",
    componentId: "sc-ec6cb697-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ModelsPage_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ModelsPage__StyledButton",
    componentId: "sc-ec6cb697-11"
})(_templateObject11(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ModelsPage = function(param) {
    var modelsData = param.modelsData, futureCarsOrderType = param.futureCarsOrderType, _type = param.type, type = _type === void 0 ? "main" : _type;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var isFinance = type === "finance";
    var isShop = type === "shop";
    var comingSoonModel = isFinance ? [] : modelsData.filter(function(item) {
        return item.carState === "Future";
    });
    var normalModels = isFinance ? modelsData : modelsData.filter(function(item) {
        return item.carState !== "Future";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelsPage_StyledWrapper, {
        ref: ref1,
        children: !!(modelsData === null || modelsData === void 0 ? void 0 : modelsData.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaQueries/* Mobile */.ij, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileBackWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelsPage_StyledButton, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {})
                            })
                        }),
                        isFinance || isShop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFinanceHeaderSmall, {
                                    children: isShop ? "התאימו אישית" : "קבלו הצעת מימון"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFinanceHeader, {
                                    children: [
                                        "בחרו דגם ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMazda, {
                                            children: "MAZDA"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFinanceHeaderSmall, {
                                    children: "כל הדגמים שלנו"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFinanceHeader, {
                                    children: [
                                        "בחרו דגם ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMazda, {
                                            children: "MAZDA"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaQueries/* Mobile */.ij, {
                    children: [
                        !!(comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.length) && futureCarsOrderType === "Start" && !isFinance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhiteSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledComingSoonText, {
                                    children: "COMING SOON"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
                                comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modelsPage_ModelCard, {
                                                modelData: item
                                            }),
                                            index !== comingSoonModel.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {})
                                        ]
                                    }, item.id);
                                })
                            ]
                        }),
                        normalModels === null || normalModels === void 0 ? void 0 : normalModels.sort(function(a, b) {
                            return a.price - b.price;
                        }).map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modelsPage_ModelCard, {
                                        inView: inView,
                                        modelData: item,
                                        type: type
                                    }),
                                    index !== normalModels.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {})
                                ]
                            }, item.id);
                        }),
                        !!(comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.length) && futureCarsOrderType === "End" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhiteSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledComingSoonText, {
                                    children: "COMING SOON"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
                                comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modelsPage_ModelCard, {
                                                inView: inView,
                                                modelData: item
                                            }),
                                            index !== comingSoonModel.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {})
                                        ]
                                    }, item.id);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaQueries/* Desktop */.Hi, {
                    children: [
                        !!(comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhiteSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledComingSoonText, {
                                    children: "COMING SOON"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarsGridWhite, {
                                    children: comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modelsPage_ModelCard, {
                                                inView: inView,
                                                modelData: item
                                            }, item.id)
                                        }, item.id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopGreySection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelsPage_StyledButton, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {})
                                }),
                                isFinance || isShop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFinanceHeaderSmall, {
                                            children: isShop ? "התאימו אישית" : "קבלו הצעת מימון"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFinanceHeader, {
                                            children: [
                                                "בחרו דגם ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMazda, {
                                                    children: "MAZDA"
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFinanceHeader, {
                                    children: [
                                        "דגמי ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMazda, {
                                            children: "MAZDA"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarsGrid, {
                                    $hasComingSoon: !!(comingSoonModel === null || comingSoonModel === void 0 ? void 0 : comingSoonModel.length),
                                    children: normalModels === null || normalModels === void 0 ? void 0 : normalModels.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modelsPage_ModelCard, {
                                            inView: inView,
                                            modelData: item,
                                            type: type
                                        }, item.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var modelsPage_ModelsPage = (ModelsPage);


/***/ }),

/***/ 1094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reusable_BackButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./reusable/icons/BackIcon.tsx






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.coffeeBrown */.Z.coffeeBrown : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 24;
    var h = 25;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.97 2.516a.75.75 0 0 1 1.061 0l9 9a.75.75 0 0 1 0 1.062l-9 9a.751.751 0 0 1-1.062-1.062l8.47-8.47-8.47-8.468a.75.75 0 0 1 0-1.062Z",
            fill: color
        })
    }));
};
/* harmony default export */ var BackIcon = (SvgComponent);

;// CONCATENATED MODULE: ./reusable/BackButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border-bottom: none;\n  margin: 0px;\n  &:hover {\n    border-bottom: none;\n    margin: 0px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "BackButton__StyledButton",
    componentId: "sc-7b449b6d-0"
})(_templateObject(), function(p) {
    return p.theme.colors.onyx;
}, function(p) {
    return p.theme.colors.onyx;
});
var BackButton = function() {
    var back = (0,router.useRouter)().back;
    var handleBack = function() {
        back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIcon, {
                width: "14px",
                height: "14px",
                color: colors/* default.onyx */.Z.onyx
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                $fontSize: "16px",
                $fontWeight: "300",
                $color: "rgb(86, 96, 102)",
                onClick: handleBack,
                children: "חזרה"
            })
        ]
    });
};
/* harmony default export */ var reusable_BackButton = (BackButton);


/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

}]);